export default "__VITE_PUBLIC_ASSET__6967b052__"